module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bootstrap-modal', {
    ref: "reportModal",
    attrs: {
      "need-header": true,
      "need-footer": true,
      "closed": _vm.closedModal,
      "size": "large"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Selecione as opções para gerar o PDF")]), _vm._v(" "), (_vm.downloadDesabilitado) ? _c('div', {
    staticClass: "alert insurer-inactive alert-danger no-margin-bottom"
  }, [_c('ul', _vm._l((_vm.mensagensDeErro), function(msg, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(msg) + "\n\t\t\t\t\t")])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row px-25px"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-1 div-title"
  }, [_vm._v("Produtos")])]), _vm._v(" "), _c('div', {
    staticClass: "row px-25px"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.todosCalculos),
      expression: "todosCalculos"
    }],
    attrs: {
      "type": "checkbox",
      "id": "chkTodosCalculos"
    },
    domProps: {
      "checked": Array.isArray(_vm.todosCalculos) ? _vm._i(_vm.todosCalculos, null) > -1 : (_vm.todosCalculos)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.todosCalculos,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.todosCalculos = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.todosCalculos = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.todosCalculos = $$c
        }
      }, function($event) {
        _vm.selecionarTodosCalculos()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chkTodosCalculos"
    }
  }, [_vm._v("Selecionar todos os cálculos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculosProdutosAdicionais),
      expression: "calculosProdutosAdicionais"
    }],
    attrs: {
      "type": "checkbox",
      "id": "chkCalculosProdutosAdicionais"
    },
    domProps: {
      "checked": Array.isArray(_vm.calculosProdutosAdicionais) ? _vm._i(_vm.calculosProdutosAdicionais, null) > -1 : (_vm.calculosProdutosAdicionais)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.calculosProdutosAdicionais,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.calculosProdutosAdicionais = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.calculosProdutosAdicionais = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.calculosProdutosAdicionais = $$c
        }
      }, function($event) {
        _vm.selecionarCalculosProdutosAdicionais()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chkCalculosProdutosAdicionais"
    }
  }, [_vm._v("Selecionar produtos adicionais")])])]), _vm._v(" "), _c('hr', {
    staticClass: "mb-8px"
  }), _vm._v(" "), _c('div', {
    staticClass: "row px-25px"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-offset-6 col-sm-6 col-md-offset-8 col-md-4 text-right"
  }, [_c('mydropdown', {
    ref: "theDropdown"
  }, [_c('div', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.theDropdown.toogle()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFiltrar Seguradoras "), _c('span', {
    staticClass: "caret"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, _vm._l((_vm.seguradoras), function(seguradora, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.filterBySeguradora(seguradora)
        }
      }
    }, [_c('img', {
      staticClass: "dropdown-seguradora-img",
      attrs: {
        "src": ("https://app.segfy.com/img/companhias/" + (seguradora.seguradora) + "_s.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "capitalize"
    }, [_vm._v(_vm._s(seguradora.seguradora))]), _vm._v(" "), (seguradora.checked) ? _c('i', {
      staticClass: "fa fa-check text-success"
    }) : _vm._e()])])
  }))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "orcamentos"
  }, _vm._l((_vm.chkOrcamentos), function(resultado, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 text-bold"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tCobertura " + _vm._s(index + 1) + " - Tipo: "), _c('span', {
      staticClass: "capitalize"
    }, [_vm._v("Produto")]), _vm._v(" - Franquia: "), _c('span', {
      staticClass: "capitalize"
    }, [_vm._v("Fanquias")])])]), _vm._v(" "), _c('div', {
      staticClass: "row no-margin"
    }, _vm._l((resultado.orcamentos), function(result) {
      return _c('div', {
        key: result.id,
        staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 orcamento no-padding",
        attrs: {
          "id": result.id
        },
        on: {
          "click": function($event) {
            _vm.addOrRemoveIfExistFromArray(_vm.filtros.Calculos, result.value, true, result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT')
          }
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', [_c('div', {
        staticClass: "col-xs-1"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.filtros.Calculos),
          expression: "filtros.Calculos"
        }],
        staticClass: "seguradora-checkbox",
        attrs: {
          "type": "checkbox",
          "disabled": result.extras.status !== 'OK' && result.extras.status.toUpperCase() !== 'ADDITIONAL_PRODUCT'
        },
        domProps: {
          "value": result.value,
          "checked": Array.isArray(_vm.filtros.Calculos) ? _vm._i(_vm.filtros.Calculos, result.value) > -1 : (_vm.filtros.Calculos)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.filtros.Calculos,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = result.value,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.filtros.Calculos = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.filtros.Calculos = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.$set(_vm.filtros, "Calculos", $$c)
            }
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "text-left",
        class: [result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT' ? 'col-xs-4' : 'col-xs-10']
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        class: [result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT' ? 'col-xs-4' : 'col-xs-1']
      }, [_c('img', {
        staticClass: "modal-seguradora-img",
        attrs: {
          "src": ("https://app.segfy.com/img/companhias/" + (result.name) + "_s.png"),
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        class: [result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT' ? 'col-xs-8' : 'col-xs-10']
      }, [_c('div', {
        staticClass: "row seguradora"
      }, [_c('div', {
        staticClass: "col-xs-12"
      }, [_vm._v(_vm._s(_vm.capitalizeEveryWord(result.name, '_') || '-'))])]), _vm._v(" "), _c('div', {
        staticClass: "row comissao"
      }, [_c('div', {
        staticClass: "col-xs-12"
      }, [(result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT') ? _c('span', [_vm._v(_vm._s(result.extras.comissao || '0') + "%")]) : _c('span', [_c('i', {
        staticClass: "fa fa-exclamation-triangle text-yellow"
      }), _vm._v(" Seguradora apresentou restrição\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])])])])]), _vm._v(" "), (result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT') ? _c('div', {
        staticClass: "col-xs-6 text-right"
      }, [_c('div', {
        staticClass: "row valor"
      }, [_c('div', {
        staticClass: "col-xs-12"
      }, [_vm._v(_vm._s(result.extras.valor || 'R$ 0,00'))])]), _vm._v(" "), _c('div', {
        staticClass: "row produto"
      }, [(result.extras.status === 'OK') ? _c('div', {
        staticClass: "col-xs-12 encurta-texto"
      }, [_vm._v(_vm._s(result.extras.produto || '-'))]) : _c('div', {
        staticClass: "col-xs-12 encurta-texto"
      }, [_vm._v("PRODUTO ADICIONAL")])])]) : _vm._e()])])])
    }))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-offset-6 col-sm-6 col-md-4 col-md-offset-8 px-25px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.IncluirDadosSegurado),
      expression: "filtros.IncluirDadosSegurado"
    }],
    attrs: {
      "type": "checkbox",
      "id": "chkDadosSegurado"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.IncluirDadosSegurado) ? _vm._i(_vm.filtros.IncluirDadosSegurado, null) > -1 : (_vm.filtros.IncluirDadosSegurado)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.IncluirDadosSegurado,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.filtros.IncluirDadosSegurado = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.filtros.IncluirDadosSegurado = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.filtros, "IncluirDadosSegurado", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chkDadosSegurado"
    }
  }, [_vm._v("Incluir dados do segurado")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 mb-8px"
  }, [_c('div', {
    staticClass: "row px-25px"
  }, [_c('div', {
    staticClass: "col-xs-12 div-title"
  }, [_vm._v("Formas de Pagamento")])]), _vm._v(" "), _c('div', {
    staticClass: "row px-25px"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "formas-de-pagamento"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.chkFormasPagamento.geral), function(forma) {
    return _c('div', {
      key: forma.id,
      staticClass: "col-xs-6 col-xs-12 col-sm-12 col-md-6 col-md-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formasSelecionadas.geral),
        expression: "formasSelecionadas.geral"
      }],
      attrs: {
        "type": "checkbox",
        "for": forma.id,
        "disabled": _vm.disabledGeral
      },
      domProps: {
        "value": forma.value,
        "checked": Array.isArray(_vm.formasSelecionadas.geral) ? _vm._i(_vm.formasSelecionadas.geral, forma.value) > -1 : (_vm.formasSelecionadas.geral)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selecionarFormasDePagamento(_vm.formasSelecionadas.geral, forma.value, true, true, _vm.disabledGeral ? true : false)
        },
        "change": function($event) {
          var $$a = _vm.formasSelecionadas.geral,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = forma.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.formasSelecionadas.geral = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.formasSelecionadas.geral = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.formasSelecionadas, "geral", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": forma.id
      },
      on: {
        "click": function($event) {
          _vm.selecionarFormasDePagamento(_vm.formasSelecionadas.geral, forma.value, true, true, _vm.disabledGeral)
        }
      }
    }, [_vm._v(_vm._s(forma.name))])])
  }))])]), _vm._v(" "), (_vm.verificaSeHaOrcamentoComSeguradora('bradesco')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  }, [_vm._v("Exclusivo Bradesco")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.chkFormasPagamento.bradesco), function(forma) {
    return _c('div', {
      key: forma.id,
      staticClass: "col-xs-6 col-xs-12 col-sm-12 col-md-6 col-md-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formasSelecionadas.bradesco),
        expression: "formasSelecionadas.bradesco"
      }],
      attrs: {
        "type": "checkbox",
        "for": forma.id,
        "disabled": _vm.disabledBradesco
      },
      domProps: {
        "value": forma.value,
        "checked": Array.isArray(_vm.formasSelecionadas.bradesco) ? _vm._i(_vm.formasSelecionadas.bradesco, forma.value) > -1 : (_vm.formasSelecionadas.bradesco)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selecionarFormasDePagamento(_vm.formasSelecionadas.bradesco, forma.value, true, true, _vm.disabledBradesco)
        },
        "change": function($event) {
          var $$a = _vm.formasSelecionadas.bradesco,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = forma.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.formasSelecionadas.bradesco = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.formasSelecionadas.bradesco = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.formasSelecionadas, "bradesco", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": forma.id
      },
      on: {
        "click": function($event) {
          _vm.selecionarFormasDePagamento(_vm.formasSelecionadas.bradesco, forma.value, true, true, _vm.disabledBradesco)
        }
      }
    }, [_vm._v(_vm._s(forma.name))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.verificaSeHaOrcamentoComSeguradora('porto') || _vm.verificaSeHaOrcamentoComSeguradora('azul')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  }, [_vm._v("Exclusivo Porto e Azul")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.chkFormasPagamento.porto), function(forma) {
    return _c('div', {
      key: forma.id,
      staticClass: "col-xs-6 col-xs-12 col-sm-12 col-md-6 col-md-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formasSelecionadas.porto),
        expression: "formasSelecionadas.porto"
      }],
      attrs: {
        "for": forma.id,
        "type": "checkbox",
        "disabled": _vm.disabledPorto
      },
      domProps: {
        "value": forma.value,
        "checked": Array.isArray(_vm.formasSelecionadas.porto) ? _vm._i(_vm.formasSelecionadas.porto, forma.value) > -1 : (_vm.formasSelecionadas.porto)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selecionarFormasDePagamento(_vm.formasSelecionadas.porto, forma.value, true, true, _vm.disabledPorto)
        },
        "change": function($event) {
          var $$a = _vm.formasSelecionadas.porto,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = forma.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.formasSelecionadas.porto = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.formasSelecionadas.porto = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.formasSelecionadas, "porto", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": forma.id
      },
      on: {
        "click": function($event) {
          _vm.selecionarFormasDePagamento(_vm.formasSelecionadas.porto, forma.value, true, true, _vm.disabledPorto)
        }
      }
    }, [_vm._v(_vm._s(forma.name))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.verificaSeHaOrcamentoComSeguradora('hdi')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  }, [_vm._v("Exclusivo HDI")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.chkFormasPagamento.hdi), function(forma) {
    return _c('div', {
      key: forma.id,
      staticClass: "col-xs-6 col-xs-12 col-sm-12 col-md-6 col-md-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formasSelecionadas.hdi),
        expression: "formasSelecionadas.hdi"
      }],
      attrs: {
        "type": "checkbox",
        "for": forma.id,
        "disabled": _vm.disabledHdi
      },
      domProps: {
        "value": forma.value,
        "checked": Array.isArray(_vm.formasSelecionadas.hdi) ? _vm._i(_vm.formasSelecionadas.hdi, forma.value) > -1 : (_vm.formasSelecionadas.hdi)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selecionarFormasDePagamento(_vm.formasSelecionadas.hdi, forma.value, true, true, _vm.disabledHdi)
        },
        "change": function($event) {
          var $$a = _vm.formasSelecionadas.hdi,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = forma.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.formasSelecionadas.hdi = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.formasSelecionadas.hdi = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.formasSelecionadas, "hdi", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": forma.id
      },
      on: {
        "click": function($event) {
          _vm.selecionarFormasDePagamento(_vm.formasSelecionadas.hdi, forma.value, true, true, _vm.disabledHdi)
        }
      }
    }, [_vm._v(_vm._s(forma.name))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.verificaSeHaOrcamentoComSeguradora('zurich')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  }, [_vm._v("Exclusivo Zurich")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.chkFormasPagamento.zurich), function(forma) {
    return _c('div', {
      key: forma.id,
      staticClass: "col-xs-6 col-xs-12 col-sm-12 col-md-6 col-md-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formasSelecionadas.zurich),
        expression: "formasSelecionadas.zurich"
      }],
      attrs: {
        "type": "checkbox",
        "for": forma.id,
        "disabled": _vm.disabledZurich
      },
      domProps: {
        "value": forma.value,
        "checked": Array.isArray(_vm.formasSelecionadas.zurich) ? _vm._i(_vm.formasSelecionadas.zurich, forma.value) > -1 : (_vm.formasSelecionadas.zurich)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selecionarFormasDePagamento(_vm.formasSelecionadas.zurich, forma.value, true, true, _vm.disabledZurich)
        },
        "change": function($event) {
          var $$a = _vm.formasSelecionadas.zurich,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = forma.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.formasSelecionadas.zurich = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.formasSelecionadas.zurich = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.formasSelecionadas, "zurich", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": forma.id
      },
      on: {
        "click": function($event) {
          _vm.selecionarFormasDePagamento(_vm.formasSelecionadas.zurich, forma.value, true, true, _vm.disabledZurich)
        }
      }
    }, [_vm._v(_vm._s(forma.name))])])
  }))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row px-25px"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 div-title"
  }, [_vm._v("Quantidade de parcelas")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.todasParcelas),
      expression: "todasParcelas"
    }],
    attrs: {
      "type": "checkbox",
      "id": "chkTodasParcelas"
    },
    domProps: {
      "checked": Array.isArray(_vm.todasParcelas) ? _vm._i(_vm.todasParcelas, null) > -1 : (_vm.todasParcelas)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.todasParcelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.todasParcelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.todasParcelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.todasParcelas = $$c
        }
      }, function($event) {
        _vm.selecionarTodos(_vm.chkParcelas, _vm.filtros.ParcelasImprimiveis, _vm.todasParcelas)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chkTodasParcelas"
    }
  }, [_vm._v("Selecionar todas as parcelas")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.chkParcelas), function(parcela) {
    return _c('div', {
      key: parcela.id,
      staticClass: "col-xs-6 col-sm-4 col-md-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filtros.ParcelasImprimiveis),
        expression: "filtros.ParcelasImprimiveis"
      }],
      attrs: {
        "type": "checkbox",
        "id": parcela.id
      },
      domProps: {
        "value": parcela.value,
        "checked": Array.isArray(_vm.filtros.ParcelasImprimiveis) ? _vm._i(_vm.filtros.ParcelasImprimiveis, parcela.value) > -1 : (_vm.filtros.ParcelasImprimiveis)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.filtros.ParcelasImprimiveis,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = parcela.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.filtros.ParcelasImprimiveis = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.filtros.ParcelasImprimiveis = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.filtros, "ParcelasImprimiveis", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": parcela.id
      }
    }, [_vm._v(_vm._s(parcela.name) + "ª parcela")])])
  }))])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "exibirComissao"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.ExibirComissao),
      expression: "filtros.ExibirComissao"
    }],
    attrs: {
      "type": "checkbox",
      "id": "chkExibirComissao"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.ExibirComissao) ? _vm._i(_vm.filtros.ExibirComissao, null) > -1 : (_vm.filtros.ExibirComissao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.ExibirComissao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.filtros.ExibirComissao = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.filtros.ExibirComissao = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.filtros, "ExibirComissao", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chkExibirComissao"
    }
  }, [_vm._v("Exibir Comissão (Resolução 382/20 SUSEP)")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.downloadDesabilitado ? true : false
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.imprimir()
      }
    }
  }, [_vm._v("Baixar PDF")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f2fa412","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/enterprise/modules/Result/NewPrintModal.vue
// module id = 336
// module chunks = 0